























import {Component, Vue} from "vue-property-decorator";
import BaseOverview, {Loadable} from "@/resources/components/BaseOverview.vue";
import Project from "@/app/models/Project";
import {debounce} from 'lodash';

@Component({
    components: {
        "base-overview": BaseOverview,
    },
})
export default class Index extends Vue {
    searchString: string = '';
    $refs!: {
        overview: BaseOverview
    }
    search = debounce(() => this.$refs.overview.reset(), 250)

    async loadItems(loadable: Loadable) {
        loadable.loadItems(
            (await Project.index(loadable.page, {
                search: this.searchString,
            })).data
        );
    }
}
